import { EMPTY_OBJECT } from '../../../constants/common'
import { Status } from '../../Status'
import { TableCellBase, TableEmptyCell } from '../../Table'

function TaskTableRowPriority({ item, ...restProps }) {
  const { priority } = item

  const { value } = priority || EMPTY_OBJECT

  return value ? (
    <TableCellBase {...restProps}>
      <Status
        showTooltip
        backgroundColor='var(--secondary-text-color-10)'
        text={value}
        textColor='var(--main-text-color)'
      />
    </TableCellBase>
  ) : (
    <TableEmptyCell {...restProps} />
  )
}

export default TaskTableRowPriority
